import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useTheme } from "../../../hooks";
import { containerStyle, otpCssStyles, getInputStyle } from "../../../styles/shared/otpInput";
export const OTPInput = ({ value, onChange, maxLength = 6, disabled = false, isError = false, autoFocus = false, }) => {
    const theme = useTheme();
    const inputRefs = React.useRef([]);
    const [focusedIndex, setFocusedIndex] = React.useState(null);
    const handleChange = (index, digit) => {
        if (!/^\d*$/.test(digit))
            return;
        const newValue = value.split("");
        newValue[index] = digit;
        const result = newValue.join("").slice(0, maxLength);
        onChange(result);
        if (digit && index < maxLength - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };
    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !value[index] && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
        if (e.key === "ArrowLeft" && index > 0) {
            inputRefs.current[index - 1]?.focus();
        }
        if (e.key === "ArrowRight" && index < maxLength - 1) {
            inputRefs.current[index + 1]?.focus();
        }
    };
    const handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData
            .getData("text")
            .replace(/\D/g, "")
            .slice(0, maxLength);
        onChange(pastedData);
        const focusIndex = Math.min(pastedData.length, maxLength - 1);
        inputRefs.current[focusIndex]?.focus();
    };
    React.useEffect(() => {
        if (autoFocus && inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, [autoFocus]);
    return (_jsxs("div", { style: containerStyle, children: [_jsx("style", { children: otpCssStyles }), _jsx("div", { className: "medos-otp-container", children: Array.from({ length: maxLength }).map((_, index) => (_jsx("input", { ref: (el) => {
                        inputRefs.current[index] = el;
                    }, type: "text", inputMode: "numeric", autoComplete: "one-time-code", maxLength: 1, value: value[index] || "", onChange: (e) => handleChange(index, e.target.value), onKeyDown: (e) => handleKeyDown(index, e), onPaste: handlePaste, onFocus: () => setFocusedIndex(index), onBlur: () => setFocusedIndex(null), disabled: disabled, className: "medos-otp-input", style: getInputStyle(theme, value, focusedIndex, isError, index) }, `otp-${index}`))) })] }));
};
